import { Attachment, BaseModel } from './common'
import { MLTrainingJob } from './MLTrainingJob'

export enum MachineLearningDataType {
  VOICE = 'voice'
}

export interface MachineLearningModel extends BaseModel {
  name: string
  inputType: MachineLearningDataType
  outputType: MachineLearningDataType
  mediaCollectionId: number
  modelFile?: Attachment
  originalModelS3Location: string
  mlTrainingJobId?: number
  mlTrainingJob?: MLTrainingJob
}
